export const ROUTE_PATHS = {
  ROOT: "/",
  CONNECT: "/connect",
  DASHBOARD: "/dashboard",
} as const;
